import { Suspense, useRef, type ReactNode } from 'react'
import { HiXMark } from 'react-icons/hi2'
import { Dialog, DialogContent, DialogDescription, DialogTitle } from '../../components/ui/dialog'
import { useCloseHomePanel } from '../../common/workspaceNavigation'

export default function HomeRouteModal({ title, children }: { title: string; children: ReactNode }) {
  const close = useCloseHomePanel()
  const origin = useRef(document.activeElement as HTMLElement | null)
  const handleClose = () => {
    close()
  }
  return <Dialog open onOpenChange={open => { if (!open) handleClose() }}>
    <DialogContent fullScreen className="hp-route-dialog"
      onCloseAutoFocus={event => { event.preventDefault(); if (origin.current?.isConnected) origin.current.focus({ preventScroll: true }) }}>
      <div className="hp-route-dialog-heading">
        <div><DialogTitle>{title}</DialogTitle><DialogDescription className="sr-only">Your dashboard stays open behind this panel.</DialogDescription></div>
        <button type="button" className="hp-icon-button" onClick={handleClose} aria-label={`Close ${title.toLowerCase()}`}><HiXMark /></button>
      </div>
      <div className="hp-route-dialog-body">
        <Suspense fallback={<p className="hp-route-loading" role="status">Loading {title.toLowerCase()}…</p>}>{children}</Suspense>
      </div>
    </DialogContent>
  </Dialog>
}
